import { useForm, useWatch } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { parsePhoneNumber } from 'libphonenumber-js'
import { useIntl } from 'react-intl'

const nextyYear = new Date().getFullYear() + 1

const isValidPhone = (value) => {
  if (value.length < 10) return false
  const phoneCode = 'MX'
  const phoneNumber = parsePhoneNumber(value, phoneCode)
  return phoneNumber.isValid()
}

const isMinDigits = (value) => {
  if (value) {
    return !(value.toString().length <= 3)
  }
  return true
}

const isValidYear = (value) => {
  if (value > nextyYear) return false
  return true
}

const useSellerInformation = () => {
  const { formatMessage: f } = useIntl()

  const {
    control, formState,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        name: yup
          .string()
          .trim()
          .matches(/([a-zA-ZÀ-ÖØ-öø-ÿ])+$/, f({ id: 'PLEASE_ENTER_NAME_LETTERS' }))
          .required(f({ id: 'EASY_NECESSARY_TO_CONTINUE' })),
        lastname: yup
          .string()
          .trim()
          .matches(/([a-zA-ZÀ-ÖØ-öø-ÿ])+$/, f({ id: 'PLEASE_ENTER_NAME_LETTERS' }))
          .required(f({ id: 'EASY_NECESSARY_TO_CONTINUE' })),
        phone: yup
          .string()
          .required(f({ id: 'EASY_NECESSARY_TO_CONTINUE' }))
          .min(10, f({ id: 'EASY_PLEASE_ENTER_PHONE' }))
          .max(10, f({ id: 'EASY_PLEASE_ENTER_PHONE' }))
          .test('isValidPhone', f({ id: 'EASY_PLEASE_ENTER_PHONE' }), (v) => isValidPhone(v)),
        year: yup
          .string()
          .required(f({ id: 'EASY_NECESSARY_TO_CONTINUE' }))
          .test('isMinDigits', 'Ingresa el año completo', (v) => isMinDigits(v))
          .test('isValidYear', 'Ingresa un año menor', (v) => isValidYear(v)),
        maker: yup
          .string()
          .trim()
          .matches(/^[aA-zZ-ZÀ-ÖØ-öø-ÿ\s]+$/, f({ id: 'PLEASE_ENTER_NAME_LETTERS' }))
          .required(f({ id: 'EASY_NECESSARY_TO_CONTINUE' })),
        model: yup
          .string()
          .trim()
          .required(f({ id: 'EASY_NECESSARY_TO_CONTINUE' })),
        office: yup.string()
          .required(f({ id: 'EASY_NECESSARY_TO_CONTINUE' })),
        day: yup.string()
          .required(f({ id: 'EASY_NECESSARY_TO_CONTINUE' })),
        time: yup.string()
          .required(f({ id: 'EASY_NECESSARY_TO_CONTINUE' })),
      }),
    ),
    defaultValues: {
      name: '',
      lastname: '',
      phone: '',
      year: '',
      maker: '',
      model: '',
      office: '',
      day: '',
      time: '',
    },
    mode: 'onChange',
  })
  const [name, lastname, phone, year, maker, model, office, day, time] = useWatch({
    control,
    name: ['name', 'lastname', 'phone', 'year', 'maker', 'model', 'office', 'day', 'time'],
  })

  return {
    setFormValue: setValue,
    formState,
    control,
    getValues,
    name,
    lastname,
    phone,
    year,
    maker,
    model,
    office,
    day,
    time,
  }
}

export default useSellerInformation
